import { render } from "./kumo2.vue?vue&type=template&id=5691f0ba&scoped=true"
import script from "./kumo2.vue?vue&type=script&lang=js"
export * from "./kumo2.vue?vue&type=script&lang=js"

import "./kumo2.vue?vue&type=style&index=0&id=5691f0ba&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5691f0ba"]])

export default __exports__